// © Microsoft Corporation. All rights reserved.
import { SocialAPIRequestErrorComments, SocialAPIRequestErrorContents, SocialAPIRequestErrorUnknown, SocialAPIRequestErrorUsers } from "@msnews/diagnostics";

export const ApiErrors = {
    unknown: SocialAPIRequestErrorUnknown,
    contents: SocialAPIRequestErrorContents,
    users: SocialAPIRequestErrorUsers,
    comments: SocialAPIRequestErrorComments
};